import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getCachedCoordinate, getCountryCoordinates, setCountryCoordinate } from '../utils/countryCoordinates';

const $ = jQuery;
const $casesCards = $('.js-case-map--card');
const $select = $('.js-cases-map--select');
let cardsData = [];
let countryData = [];
let map = null;

// Add new variable to store project counts per country
let countryProjectCounts = {};

let countryIsoCodes = [];

/**
 * Guarantees map module
 */
export function guaranteesMapModule() {
    const casesMap = document.getElementById('cases-map--map-box');
    if (casesMap && document.querySelector('section.guarantees')) {
        getCountryData();
        getAllCaseCardsData();
        setHoverStateForCasesCards();
        showFilters();
        resetFilters();
    }

    $('.guarantees .js-cases-map--taxonomy[data-taxonomy="country"] .cases-map__taxonomy-item').each(function () {
        countryIsoCodes.push($(this).data('country'));
    });

    countryIsoCodes = [...new Set(countryIsoCodes)];
}

let isoCodeCoordinates;

/**
 * Init mapbox map
 */
export async function initCasesMap(countryData, centerMap = false) {
    // Init map
    mapboxgl.accessToken = 'pk.eyJ1IjoidG9tLWVkZmkiLCJhIjoiY21hbnR1emt6MDJvYzJvc2c4Nmd4eW1iNyJ9.GwYZjGDw0JQ3suyPLhPLFg';
    map = new mapboxgl.Map({
        container: 'cases-map--map-box',
        style: 'mapbox://styles/tom-edfi/cmbetzox0004t01scdxdt087m',
        center: [-10, 8.04444],
        zoom: 0,
        pitch: 0,
        bearing: 0,
        interactive: true,
        doubleClickZoom: false,
        dragRotate: false,
        scrollZoom: false,
        maxZoom: 4.5,
        minZoom: 2.5,
    });
    // add button to zoom in/out
    map.addControl(
        new mapboxgl.NavigationControl({
            showCompass: false,
            showZoom: true,
        }),
        'bottom-right',
    );

    // Resolve coordinates for each ISO code using the local dataset with a remote fallback
    isoCodeCoordinates = await Promise.all(
        countryData.map(async (country) => {
            const isoCodeUpper = (country.code || '').toUpperCase();
            let coordinates = getCountryCoordinates(isoCodeUpper);

            if (!coordinates) {
                coordinates = await fetchCountryCoordinate(isoCodeUpper);
            }

            if (!coordinates) {
                console.warn(`[guaranteesMap] Unable to resolve coordinates for ISO code: ${isoCodeUpper}`);
            }

            return { isoCode: isoCodeUpper, coordinates, type: country.type };
        }),
    );

    // Add country polygons to map
    map.on('load', () => {
        map.addSource('countries', {
            type: 'vector',
            url: 'mapbox://mapbox.country-boundaries-v1',
        });

        map.addLayer({
            id: 'country-fills',
            type: 'fill',
            source: 'countries',
            'source-layer': 'country_boundaries',
            layout: {},
            paint: {
                'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'open'], false],
                    '#D1E3FF', // Color when open for investment
                    ['boolean', ['feature-state', 'selected'], false],
                    '#DA2D44', // Color when highlighted
                    ['boolean', ['feature-state', 'hover'], false],
                    '#5B82D5', // Color when hovered
                    ['boolean', ['feature-state', 'highlighted'], false],
                    '#96ACE3', // Color when highlighted
                    ['>=', ['feature-state', 'project_count'], 5],
                    '#520304',
                    ['>=', ['feature-state', 'project_count'], 3],
                    '#A70003',
                    ['>=', ['feature-state', 'project_count'], 1],
                    '#DA2D44',
                    '#F7F7F7', // Default color
                ],
            },
        });

        if ($('.guarantees').hasClass('cases-map--no-filters') || centerMap) {
            centerMapOnSelectedCountries(countryData);
        }

        map.addLayer({
            id: 'country-borders',
            type: 'line',
            source: 'countries',
            'source-layer': 'country_boundaries',
            layout: {},
            paint: {
                'line-color': '#B9B9B9',
                'line-width': 0.2,
            },
        });

        map.on('mousemove', 'country-fills', (e) => {
            if (e.features.length > 0) {
                const feature = e.features[0];
                const isoCode = feature.properties.iso_3166_1;
                if (countryIsoCodes.includes(isoCode)) {
                    map.getCanvas().style.cursor = 'pointer';
                } else {
                    map.getCanvas().style.cursor = 'grab';
                }
            } else {
                map.getCanvas().style.cursor = 'grab';
            }
        });

        map.on('click', 'country-fills', (e) => {
            if (e.features.length > 0) {
                let wrapper;
                if (window.innerWidth > 1024) {
                    wrapper = '.guarantees .js-cases-map--taxonomies-wrapper';
                } else {
                    wrapper = '.guarantees .js-cases-map--taxonomies-wrapper-mobile';
                }

                const feature = e.features[0];
                const isoCode = feature.properties.iso_3166_1;

                if (countryIsoCodes.includes(isoCode)) {
                    const item = $(`${wrapper} .js-cases-map--taxonomy[data-taxonomy="country"] .cases-map__taxonomy-item[data-country="${isoCode}"]`);
                    $(`${wrapper} .js-cases-map--taxonomy[data-taxonomy="country"] .cases-map__taxonomy-item`).not(item).find('input').prop('checked', false);
                    const $input = item.find('input');
                    $input.prop('checked', true);
                    $input.trigger('change');

                    let countryName = item.find('label').text();
                    const title = $('.guarantees .cases-map__title em');
                    const subtitle = $('.guarantees .cases-map__subtitle');
                    title.data('country-name', title.text());
                    title.text(countryName);

                    subtitle.text(`${subtitle.data('country-name')} in: ${countryName}`);
                } else {
                    $('.guarantees .js-cases-map--taxonomy[data-taxonomy="country"] input:checked').each(function () {
                        $(this).prop('checked', false);
                    });

                    $('.guarantees .js-cases-map--taxonomy[data-taxonomy="country"] input:first-child').trigger('change');
                }
            }
        });
    });

    map.once('idle', () => {
        map.querySourceFeatures('countries', { sourceLayer: 'country_boundaries' }).forEach((feature) => {
            const isoCode = feature.properties.iso_3166_1;
            const projectCount = countryProjectCounts[isoCode] || 0;

            // Set project count for each country
            const featureState = {
                project_count: projectCount,
            };

            map.setFeatureState(
                {
                    source: 'countries',
                    sourceLayer: 'country_boundaries',
                    id: feature.id,
                },
                featureState,
            );
        });
    });
}

function updateMap() {
    map.querySourceFeatures('countries', { sourceLayer: 'country_boundaries' }).forEach((feature) => {
        const isoCode = feature.properties.iso_3166_1;
        const projectCount = countryProjectCounts[isoCode] || 0;
        const title = $('.guarantees .cases-map__title em');
        const subtitle = $('.guarantees .cases-map__subtitle');
        title.data('country-name') ? title.text(title.data('country-name')) : title.text();
        subtitle.data('country-name') ? subtitle.text(subtitle.data('country-name')) : subtitle.text();

        map.setFeatureState(
            {
                source: 'countries',
                sourceLayer: 'country_boundaries',
                id: feature.id,
            },
            { project_count: projectCount },
        );
    });

    map.triggerRepaint();
}

function centerMapOnSelectedCountries(countryData) {
    const bounds = new mapboxgl.LngLatBounds();

    isoCodeCoordinates.forEach(({ coordinates }) => {
        if (coordinates && coordinates.length === 2) {
            bounds.extend(coordinates);
        }
    });

    if (!bounds.isEmpty()) {
        map.fitBounds(bounds, {
            padding: 50, // Add padding around the bounds
            maxZoom: 0, // Optional: set a maximum zoom level
        });
    }
}

/**
 * Get all data from cards
 */
function getAllCaseCardsData() {
    $('.guarantees .js-case-map--card').each(function (key, value) {
        const $this = $(this);

        cardsData.push({
            id: $this.data('post-id'),
            countries: caseData($this, 'countries'),
            sector: caseData($this, 'sector'),
            facility: caseData($this, 'facility'),
            year: caseData($this, 'year'),
        });
    });
}

function caseData($card, type) {
    let data = $card.data(type);
    if (!data) {
        return [];
    }

    if (!isNaN(data)) {
        return [data];
    }

    if (data.indexOf(',') === -1) {
        return [data];
    }

    data = data.split(',');
    if (type === 'countries') {
        data.forEach(function (value, key) {
            data[key] = value.toUpperCase();
        });
    }

    return data;
}

/**
 * Set hover state for cases cards
 */
function setHoverStateForCasesCards() {
    $('.guarantees .js-case-map--card').on('mouseenter', function (e) {
        $('.cases-map__marker').removeClass('active');
        const $this = $(this);
        const countries = $this.data('countries');
        const countriesArray = countries.split(',');

        countriesArray.forEach(function (value, key) {
            countriesArray[key] = value.toUpperCase();
        });

        countriesArray.forEach(function (value, key) {
            if (countryData.includes(value)) {
                $('.cases-map__marker')
                    .filter('[data-iso-code="' + value + '"]')
                    .addClass('active');
            }
        });
    });
}

/**
 * Get all countries from select
 */
export function getCountryData(countryData = []) {
    let data = [];

    if (countryData.length === 0) {
        const $countries = $('.guarantees .js-cases-map--taxonomy[data-taxonomy="country"] .cases-map__taxonomy-item');

        $countries.each(function () {
            const $this = $(this);
            const countryCode = $this.data('country');
            if (countryCode) {
                data.push({ code: countryCode, type: 'main' });
            }
        });

        const $guaranteesMap = $('.guarantees');
        const investmentCountries = $guaranteesMap.data('investment-countries');

        if (investmentCountries) {
            const investmentCountryArray = investmentCountries.split(',');
            investmentCountryArray.forEach((countryCode) => {
                if (countryCode && !data.find((item) => item.code === countryCode)) {
                    data.push({ code: countryCode, type: 'investment' });
                }
            });
        }
    } else {
        countryData.forEach((item) => {
            data.push({ code: item, type: 'main' });
        });
    }

    countProjectsPerCountry();

    if (map) {
        updateMap(data);
    } else {
        initCasesMap(data, countryData.length > 0);
    }
}

function showFilters() {
    $('.guarantees .js-cases-map--toggler').on('click', function (e) {
        e.preventDefault();
        $('.guarantees .cases-map__sidebar').toggleClass('active');
    });
}

function resetFilters() {
    let $resetBtn = $('.guarantees .js-cases-map--reset');
    $resetBtn.on('click', function (e) {
        e.preventDefault();
        $('.guarantees .js-cases-map--select').val(null).trigger('change');
    });
}

/**
 * Count projects per country
 */
function countProjectsPerCountry() {
    const $activeCountries = $('.guarantees .js-cases-map--taxonomy[data-taxonomy="country"] input:checked');
    countryProjectCounts = {};

    if ($activeCountries.length === 0) {
        $('.guarantees .js-case-map--card:not([style*="display: none"])').each(function () {
            if ($activeCountries.length > 1 || $activeCountries.length === 0) {
                const $this = $(this);
                const countries = $this.data('countries');

                if (countries) {
                    const countryArray = countries.split(',');
                    countryArray.forEach((country) => {
                        const countryCode = country.toUpperCase().trim();
                        countryProjectCounts[countryCode] = (countryProjectCounts[countryCode] || 0) + 1;
                    });
                }
            }
        });
    }

    if ($activeCountries.length > 0) {
        $activeCountries.each(function () {
            const $this = $(this);
            const $countryParent = $this.closest('.cases-map__taxonomy-item');
            const countryCode = $countryParent.data('country');

            countryProjectCounts[countryCode] = getCountryCasesCount(countryCode);
        });
    }
}

function getCountryCasesCount(countryCode = null) {
    let count = 0;
    // $('.guarantees .js-case-map--card:not([style*="display: none"])').each(function () {
    //     count += (countryProjectCounts[countryCode] || 0) + 1;
    // });

    $('.guarantees .js-case-map--card').each(function () {
        const $this = $(this);
        const countries = $this.data('countries');
        const countriesArray = countries.split(',');

        countriesArray.forEach(function (value, key) {
            countriesArray[key] = value.toUpperCase();
        });

        if (countriesArray.includes(countryCode)) {
            count += 1;
        }
    });

    return count;
}

async function fetchCountryCoordinate(isoCode, accessToken = mapboxgl.accessToken) {
    if (!isoCode) {
        return null;
    }

    const cached = getCachedCoordinate(isoCode);
    if (cached) {
        return cached;
    }

    if (!accessToken) {
        return null;
    }

    const query = encodeURIComponent(isoCode);
    const endpoints = [`https://api.mapbox.com/search/geocode/v6/forward?q=${query}&types=country&access_token=${accessToken}`, `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?types=country&access_token=${accessToken}`];

    // eslint-disable-next-line no-restricted-syntax
    for (const url of endpoints) {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                // eslint-disable-next-line no-continue
                continue;
            }

            const data = await response.json();
            const feature = data.features && data.features[0];

            if (feature && feature.geometry && Array.isArray(feature.geometry.coordinates)) {
                const coordinates = feature.geometry.coordinates.slice(0, 2);
                setCountryCoordinate(isoCode, coordinates);
                return coordinates;
            }
        } catch (error) {
            console.warn(`[guaranteesMap] Failed to fetch coordinates for ISO code ${isoCode}`, error);
        }
    }

    return null;
}
